
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/listing/[[...listing]]",
      function () {
        return require("private-next-pages/jobs/listing/[[...listing]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/listing/[[...listing]]"])
      });
    }
  